export const patients = state => {
  return state.patients
}
